export default [
	{
		id: 1,
		projectName: "birthday reminder",
		img: "img/list.png",
		link: "https://basic-react-project1.netlify.app/",
	},
	{
		id: 2,
		projectName: "Tours",
		img: "img/tour.png",
		link: "https://q5t1r.csb.app/",
	},
	{
		id: 3,
		projectName: "Carousel",
		img: "img/review.png",
		link: "https://bzcog.csb.app/",
	},
	{
		id: 4,
		projectName: "Accordion",
		img: "img/accordion.png",
		link: "https://v7wgz.csb.app/",
	},
	{
		id: 5,
		projectName: "Slider",
		img: "img/slider.png",
		link: "https://4ltk3.csb.app/"
	},
	{
		id: 6,
		projectName: "Menu",
		img: "img/Menu.png",
		link: "https://filtermenu.netlify.app/"
	},
	{
		id: 7,
		projectName: "Jobs Tab",
		img: "img/Tab.png",
		link: "https://tender-edison-efdfeb.netlify.app/"
	},
	{
		id: 8,
		projectName: "Boring Lorem",
		img: "img/lorem.png",
		link: "https://3w5or.csb.app/"
	},
	{
		id: 9,
		projectName: "Tints and shades Generator",
		img: "img/shade.png",
		link: "https://tints.netlify.app/"
	},
	{
		id: 10,
		projectName: "React Todo App",
		img: "img/todo.png",
		link: "https://namskar.netlify.app"
	}

];
